const zh = {
    num: '编号',
    creator: '制单人',
    createdAt: '制单时间',
    invStatus: '盘点状态',
    opt: '操作',
    startInv: '我要盘点',
    validaFail: '校验失败',
    invalidFormat: '商品名称与数量格式必须正确',
    operator: '操作人',
    operaTime: '操作时间',
    invRequest: '盘点申请单',
    basicInfo: '基本信息',
    warehouseItems: '仓库商品',
    itemList: '商品列表',
    item: '商品',
    quantity: '数量',
    enterQuantity: '请填写入库数量',
    cancel: '取消',
    next: '下一步',
    addFailed: '添加失败',
    diffTip: '仓库条码和盘点条码进行比对，有以下差异：',
    oneClickInOut: '一键出库/入库',
    oneClickIn: '一键入库',
    oneClickOut: '一键出库',
    doError: '生成差异失败，{{err}}',
    operationTips: '当前组织正在盘点，无法进行操作。',
    createDiff: '生成差异',
    endCounting: '结束盘点',
    getDiffDataTip: '正在获取差异数据，请稍后...',
    countingDataInventorySuccs: '盘点数据出库/入库成功',
    countingFinish: '盘点完成',
    countingNoData: '盘点数据不存在',
    countingCancelDiff: '当前差异数据已生成，确定取消后将结束差异。',
    dataMatchFinish: '数据匹配完毕，无差异数据！',
    diffDataTip: '盘点单存在，仓库不存在的数据：',
    diffDataTip2: '仓库存在，盘点单中不存在的数据：',
    onClickDelete: '一键删除',
    seletedItems: '已选中{{num}}项',
    againAddScan: '再次添加扫描单',
    againDiff: '再次生成差异',
    countingDataIsOverTip: '确定要结束本次盘点吗',
    countingInSucc: '盘点入库成功',
    countingOutSucc: '盘点出库成功',
    delCountingScanBarcode: '确定删除本次盘点扫描单中该条码吗?',
    barcode: '条码',
    countingBarcodeInProduct: '盘点单中该条码所属商品',
    storeBarcodeInProduct: '仓库中该条码所属商品',
    optDetail: '详情',
    countingDetail: '盘点详情',
    countingProductData: '盘点商品数据',
    overCouting: '结束盘点',
    overCoutingTip: '确定结束该盘点单吗?',
    fillDataDoTip: '请先选择商品和填写条形码数据后再生成差异',
    noDataOverCounting: '当前暂无数据可结束盘点',
    lockState: '盘点状态',
    counting: '盘点中',
    notCounting: '未盘点',
    done: '已完成',
    selectOneLocation: '只能选择一个库位',
    locationLocked: '该库位正在盘点中，无法选择',
    pleaseSelectLocation: '请选择库位',
    addSuccess: '盘点单已生成',
    usingExistingOrder: '使用已存在的盘点单',
    noCountOrder: '盘点单不存在',
    executeSuccess: '执行成功',
    executeFailed: '执行失败',
    confirmClose: '确认关闭',
    confirmCloseContent: '关闭后，当前盘点数据将会丢失，确定要关闭吗？',
    lotStr: '批次',
    systemCount: '系统数量',
    countingCount: '盘点数量',
    barcodeDiff: '条码差异',
    noDifference: '无差异',
    inconsistent: '不一致',
    system: '系统',
    systemOnly: '仅系统有',
    countingOnly: '仅盘点有',
    selectLocation: '选择库位',
    inputCountData: '录入盘点数据',
    inputDesc: '请输入备注',
    inputProductCode: '请输入商品编码',
    inputLot: '请输入批次',
    inputCount: '请输入数量',
    count: '数量',
    barcodes: '条码',
    barcodesPlaceholder: '多个条码用逗号分隔',
    barcodeCount: '个条码',
    barcodeExceedsCount: '条码数量超出限制',
    barcodeExceedsCountDesc: '条码数量不能超过盘点数量 {{max}} 个',
    addItem: '添加商品',
    countResult: '盘点结果',
    diffComparison: '差异对比',
    complete: '完成',
    executeComplete: '盘点单执行完毕',
    executeSuccessDesc: '盘点已成功完成',
    itemsUpdated: '盘点单已更新',
    loadFailed: '加载失败',
    updateFailed: '更新失败',
    bothExist: '盘点和系统都有',
    noBarcodes: '暂无条码',
    barcodeDiffDetail: '条码差异详情',
    viewDiff: '查看差异',
    continueCounting: '继续盘点',
    diffCodes: "差异条码",
    normalCodes: "无差异条码",
    countingCodes: "盘点",
    preOutExt: "库位存在预出库，不可盘点",
    confirmDelete: "确认删除",
    confirmDeleteContent: "删除盘点单后数据将无法恢复，确定要删除吗？",
    deleteSuccess: "删除成功",
    deleteFailed: "删除失败",
    saveFailed: "保存失败",
    confirmTerminate: "确认终止盘点",
    confirmTerminateContent: "终止盘点将删除当前盘点单，确定要终止吗？",
    terminateSuccess: "盘点单已删除",
    terminateFailed: "终止盘点失败",
    noCode: "存货编码不存在：{{code}}",
    temp: "暂存",
    tempSave: "确定暂存此盘点单？",
    tempSaveConfirm: "暂存后，你将保存当前数据。",
    tempSaveSuccess: "已暂存",
    batchImport: "批量导入盘点",
    downloadTemplate: "下载模版",
    importData: "导入盘点",
    invalidTemplate: "请选择正确的模版文件",
    confirmImport: "确定导入",
    productCode: "存货编码",
    productName: "存货名称",
    productModal: "规格型号",
    productUom: "单位",
    bookNum: "帐存数量",
    countedNum: "初盘数量",
    locationIdx: "库位",
    parseDataSuccess: "成功解析 {{count}} 条数据",
    parseDataFilter: "成功解析 {{count}} 条数据，请检查已过滤异常数据（第 {{rows}} 行）",
    locationParseFailed: "以下库位解析失败: 存货编码不存在{{codes}},库位 {{locations}}",
    importSuccess: "导入盘点成功",
    countingCompleted: "盘点完成",
    confirmCloseImport: "确认关闭导入",
    confirmCloseImportContent: "关闭后，已导入的数据将会丢失，确定要关闭吗？",
    confirmDeleteRow: "确认删除",
    confirmDeleteRowContent: "确定要删除这条数据吗？",
    productCodeNotExisted: "以下物料编码不存在：「{{codes}}」",
    countingHistory: "盘点历史",
    countingHistoryAll: "盘点历史_全部",
    inventoryImportTemplate: "盘点导入模板",
    inputTemp: "从模版录入",
    noLot: "不生成批次（盘点之后生成的出入库单不生成lot）",
    initLoc: "正在准备库位数据",
    subErr: "请输入lot、存货编码、数量",
    countErr: "盘点失败",
    countErrTip: "标红行盘点不成功",
    countErrTip1: "如果有单号则已生成盘点单，盘点失败，否则未生成盘点单",
    countNo: "盘点单号",
    countErrTip2: "Excel表格中有以下数据行数据异常",
    countErrTip3: "请检查Excel表格中以下行号中的：存货编码、初盘数量、库位，是否填写正常",
    countErrTip4: "以下料号不存在",
    countErrTip5: "解析失败",
    countErrTip6: "解析数据失败，请检查表格数据，稍后重试",
    countErrTip7: "第{{index}}行",

};

export default zh;